import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { BuyerEntity } from "../dto/buyer-entity";
import { WfxImageUploadEntity } from "../dto/file-upload-entity";


@Injectable()
export class ImagesRepo extends Repository<WfxImageUploadEntity> {

    constructor(@InjectRepository(WfxImageUploadEntity) private imagesRepo: Repository<WfxImageUploadEntity>
    ) {
        super(imagesRepo.target, imagesRepo.manager, imagesRepo.queryRunner);
    }

    async getImagesOriginalNames(): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`original_name`)

        return await query.getRawMany()
    }

}